import { motion } from 'motion/react';
import { Container } from '@/components/ui/Container';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { fadeInUp, staggerContainer } from '@/lib/animations';

export function Privacy() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <Navbar />
      <main className="pt-24 pb-16 md:pt-32 md:pb-24">
        <Container size="narrow">
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            animate="visible"
          >
            <motion.h1
              variants={fadeInUp}
              className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-8"
            >
              Politica de Privacidad
            </motion.h1>

            <motion.div
              variants={fadeInUp}
              className="prose prose-gray dark:prose-invert max-w-none"
            >
              <p className="text-gray-600 dark:text-slate-400 mb-6">
                Ultima actualizacion: Enero 2025
              </p>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  1. Informacion que Recopilamos
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  En Affogato, recopilamos la informacion necesaria para proporcionar nuestros servicios:
                </p>
                <ul className="list-disc pl-6 text-gray-600 dark:text-slate-400 space-y-2">
                  <li>Informacion de cuenta: nombre, correo electronico y contrasena</li>
                  <li>Datos de uso: archivos subidos, actividad en portales y preferencias</li>
                  <li>Informacion tecnica: direccion IP, tipo de navegador y dispositivo</li>
                  <li>Datos de pago: procesados de forma segura por nuestros proveedores de pago</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  2. Como Usamos tu Informacion
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Utilizamos tu informacion para:
                </p>
                <ul className="list-disc pl-6 text-gray-600 dark:text-slate-400 space-y-2">
                  <li>Proporcionar, mantener y mejorar nuestros servicios</li>
                  <li>Procesar transacciones y enviar notificaciones relacionadas</li>
                  <li>Responder a tus consultas y proporcionar soporte</li>
                  <li>Enviarte actualizaciones sobre el servicio (puedes optar por no recibirlas)</li>
                  <li>Detectar y prevenir actividades fraudulentas o no autorizadas</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  3. Almacenamiento y Seguridad
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Tus archivos y datos se almacenan de forma segura en la infraestructura de Cloudflare,
                  con encriptacion en transito y en reposo. Implementamos medidas de seguridad
                  tecnicas y organizativas para proteger tu informacion contra acceso no autorizado,
                  alteracion o destruccion.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  4. Compartir Informacion
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  No vendemos tu informacion personal. Solo compartimos datos con:
                </p>
                <ul className="list-disc pl-6 text-gray-600 dark:text-slate-400 space-y-2">
                  <li>Proveedores de servicios que nos ayudan a operar la plataforma</li>
                  <li>Cuando lo requiera la ley o para proteger nuestros derechos legales</li>
                  <li>Con tu consentimiento explicito</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  5. Tus Derechos
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Tienes derecho a:
                </p>
                <ul className="list-disc pl-6 text-gray-600 dark:text-slate-400 space-y-2">
                  <li>Acceder a tus datos personales</li>
                  <li>Corregir datos inexactos</li>
                  <li>Solicitar la eliminacion de tus datos</li>
                  <li>Exportar tus datos en un formato portable</li>
                  <li>Oponerte al procesamiento de tus datos</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  6. Cookies
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Utilizamos cookies esenciales para el funcionamiento del servicio y cookies
                  analiticas para mejorar la experiencia del usuario. Puedes configurar tu
                  navegador para rechazar cookies, aunque algunas funcionalidades pueden verse afectadas.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  7. Cambios en esta Politica
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Podemos actualizar esta politica ocasionalmente. Te notificaremos sobre cambios
                  significativos a traves del correo electronico o mediante un aviso en la plataforma.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  8. Contacto
                </h2>
                <p className="text-gray-600 dark:text-slate-400">
                  Si tienes preguntas sobre esta politica de privacidad, puedes contactarnos en:{' '}
                  <a
                    href="mailto:hola@affogato.cloud"
                    className="text-primary-600 dark:text-primary-400 hover:underline"
                  >
                    hola@affogato.cloud
                  </a>
                </p>
              </section>
            </motion.div>
          </motion.div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
